import { ButtonToolbar, Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { useMutation } from '@apollo/client'
import type {
  IFilterData,
  IFilterOption,
} from '@rankmi/rankmi-table/dist/interfaces/filterProps'
import { Filters } from '@rankmi/rankmi-table'
import { useTranslation } from 'react-i18next'

import { IAreaModel } from 'models/area.model'
import { DOWNLOAD_USERS, TDataDownloadUsers } from 'graphqlAPI/users/mutations'
import { buildQuery } from 'helpers'
import { FilterGroup } from 'helpers/filterData.helper'
import { SuccessToast } from 'components/ui/toast/toastsTemplates'
import { DropdownReport } from 'components/dropdowns/DropdownReport'
import { useAccess } from 'contexts/AccessContext'
import { MutationDownloadUsersArgs } from '../../../../../graphqlAPI/types-graphql'
import { prefix } from '../constants'
import styles from './Buttons.module.scss'

interface ButtonsProps {
  filtersColumns: IFilterOption[]
  onChangeFilters: (filters: IAreaModel) => void
  allSelected: boolean
  selected: number[]
  total: number
  area?: IAreaModel | null
  translations?: any
  g?: (Record<string, string | string[]> | FilterGroup)[]
  sorts: string[]
  search: string
  selectedFilters?: IFilterData
  showFiltersModal: boolean
  setShowFiltersModal: (state: boolean) => void
}

export const Buttons = ({
  filtersColumns,
  onChangeFilters,
  allSelected,
  selected,
  total,
  translations,
  area,
  g,
  search,
  sorts,
  selectedFilters,
  showFiltersModal,
  setShowFiltersModal,
}: ButtonsProps) => {
  const { t } = useTranslation()
  const { access } = useAccess()
  const canDownload = access.canDownloadReportWithViewAccess()

  const [downloadUsers] = useMutation<
    TDataDownloadUsers,
    MutationDownloadUsersArgs
  >(DOWNLOAD_USERS)

  const count = !allSelected ? selected?.length : total - selected.length

  return (
    <>
      <ButtonToolbar className="float-left">
        <Filters
          columns={filtersColumns}
          selectedFilters={selectedFilters}
          onChange={(data: any) => {
            onChangeFilters(data)
          }}
          open={showFiltersModal}
          onVisibilityChange={(state: boolean) => setShowFiltersModal(state)}
          locale={translations}
        />
      </ButtonToolbar>
      {canDownload && (
        <ButtonToolbar className={`float-right`}>
          <Dropdown
            id="dropdown-manage"
            className={styles.dropdownManage}
            alignRight
          >
            <Dropdown.Toggle
              id="dropdown-manage-toggle"
              bsPrefix="noCaret"
              variant={'secondary'}
            >
              {t(`${prefix}.actions.label`)}
              <FontAwesomeIcon icon={faChevronDown} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <DropdownReport
                disabled={!count}
                onClick={async () => {
                  const { generating } = await downloadUsers({
                    variables: {
                      input: {
                        areaId: area?.id.toString(),
                        q: {
                          ...buildQuery(selected.map(Number), allSelected),
                          g,
                          search: selected.length ? null : search,
                          sorts,
                        },
                      },
                    },
                  }).then(({ data }) => ({
                    ...data?.downloadUsers,
                  }))
                  if (generating) {
                    SuccessToast(t('administration.toastMessages.downSuccess'))
                  } else {
                    SuccessToast(t('administration.toastMessages.downloadSent'))
                  }
                }}
              >
                {t(`${prefix}.actions.options.downloadReportSelected`, {
                  count,
                })}
              </DropdownReport>
            </Dropdown.Menu>
          </Dropdown>
        </ButtonToolbar>
      )}
    </>
  )
}
